import { createUseStyles } from "react-jss";

export const useStyles = createUseStyles({
  message: {
    fontSize: 16
  }
});
